import React from "react";

export const support = () => {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_33705_1719)">
        <path
          d="M11.25 0C5.03241 0 -3.05176e-05 5.0316 -3.05176e-05 11.25V21.6211C-3.05176e-05 22.1065 0.393456 22.5 0.878875 22.5H11.25C17.4675 22.5 22.5 17.4684 22.5 11.25C22.5 5.03244 17.4684 0 11.25 0ZM11.25 20.7422H1.75778V11.25C1.75778 6.00394 6.00321 1.75781 11.25 1.75781C16.496 1.75781 20.7422 6.00324 20.7422 11.25C20.7422 16.4961 16.4967 20.7422 11.25 20.7422Z"
          fill="currentColor"
        />
        <path
          d="M11.2881 7.5C12.1657 7.5 12.8695 7.73248 13.3994 8.19743C13.9293 8.65408 14.1943 9.30585 14.1943 10.1527C14.1943 10.9415 13.9376 11.5559 13.4243 11.9959C13.0163 12.3447 12.5002 12.5553 11.876 12.6278C11.6203 12.6574 11.4123 12.8633 11.4123 13.1207C11.4123 13.3799 11.2021 13.5901 10.9429 13.5901H10.4187C9.86996 13.5901 9.42512 13.1452 9.42512 12.5965V12.0188C9.42512 11.6072 9.75875 11.2736 10.1703 11.2736C10.8161 11.2736 11.3046 11.1947 11.6358 11.037C11.967 10.8709 12.1326 10.5762 12.1326 10.1527C12.1326 9.87044 12.0498 9.65041 11.8842 9.49266C11.7269 9.32661 11.5116 9.24358 11.2384 9.24358C10.9403 9.24358 10.7085 9.33076 10.5429 9.50512C10.2608 9.80293 9.97437 10.1901 9.56413 10.1901H9.2908C8.74253 10.1901 8.26677 9.74079 8.44173 9.22118C8.48842 9.08252 8.54712 8.94884 8.61784 8.82014C8.84968 8.4133 9.19329 8.09365 9.64868 7.86117C10.1041 7.62039 10.6505 7.5 11.2881 7.5ZM10.4778 14.5615C11.0762 14.5615 11.5613 15.0466 11.5613 15.645C11.5613 16.2434 11.0762 16.7285 10.4778 16.7285H10.4465C9.84813 16.7285 9.36302 16.2434 9.36302 15.645C9.36302 15.0466 9.84813 14.5615 10.4465 14.5615H10.4778Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_33705_1719">
          <rect width="22.5" height="22.5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
